import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { ClassMembership } from '../class-membership.js';
import { Teacher } from '../teacher.js';

/**
 * All of the current teacher's approved memberships, across every one of their classes — the
 * client groups these by `classRoomID` to render a per-class student-count on the classroom
 * overview. Mirrors get-pending-request-counts.ts.
 */
export const getApprovedMemberCountsQuery = registerQuery({
  operationName: 'getApprovedMemberCountsQuery',
  type: () => [ClassMembership],
  params: [],

  resolve: () => async (_gqlFields: BaseQLSelectionSet<ClassMembership>): Promise<ClassMembership[]> => {
    const currentUser = await CurrentUserInfo.getMyself()({ _id: 1 });
    if (!currentUser?._id) return [];

    const teacherCollection = await getCollection(Teacher);
    const teacher = await teacherCollection.findOne({ userID: currentUser._id });
    if (!teacher) return [];

    const membershipCollection = await getCollection(ClassMembership);
    const memberships = await membershipCollection.find({ teacherID: teacher._id, status: 'approved' }).toArray();

    return memberships as ClassMembership[];
  },
});
